import {
  TAssetEventLogPayload,
  TChannelEventLogPayload,
  TFeedbackEventLogPayload,
} from "../models/event-logs";
import instance from "../utils/instance";

export const generateChannelEventLog = (payload: TChannelEventLogPayload) => {
  return instance.post("/event-log/channel", payload);
};

export const generateAssetEventLog = (payload: TAssetEventLogPayload) => {
  return instance.post("/event-log/asset", payload);
};

export const generateFeedbackEventLog = (payload: TFeedbackEventLogPayload) => {
  return instance.post("/event-log/feedback", payload);
};
